module.exports = __webpack_public_path__ + "img/w77.9e6583f5.svg";